import forEach from '../../../../javascripts/dom/forEach';

const mediathek = document.querySelectorAll('[data-js-module="o-mediathek"]');

const init = async () => {

};

if (mediathek.length ) init();
